import React from 'react';
import PropTypes from 'prop-types';

import Styles from './styles';

const ButtonOnMap = ({ children, show, ...props }) =>
  show && <Styles.ButtonOnMap {...props}>{children}</Styles.ButtonOnMap>;

ButtonOnMap.defaultProps = {
  numberOfButtonsTop: 0,
  numberOfButtonsRight: 0,
  show: true
};

ButtonOnMap.propTypes = {
  children: PropTypes.node.isRequired,
  numberOfButtonsTop: PropTypes.number,
  numberOfButtonsRight: PropTypes.number,
  show: PropTypes.bool
};

export default ButtonOnMap;
